import * as React from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import CloudUploadIcon from '../images/ant-design_cloud-upload-outlined.png';

export default function UploadImage({ setImage, inputID, btnName }) {
    const config = useStoreState((state) => state.config);

    const uploadImage = () => {
        const myFile = document.getElementById(inputID);
        myFile.click();
        myFile.onchange = function () {
            let file = myFile.files[0];
            let image = file;
            let formData = new FormData();
            formData.append('image', image);
            let requestUploadImage = new XMLHttpRequest();
            requestUploadImage.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    const url = this.response;
                    console.log('url', url);
                    setImage(url);
                }
            };
            requestUploadImage.open('POST', config.endpoint + '/api/donation/upload', true);
            requestUploadImage.send(formData);
        };
    };
    const handleClickUpload = () => {
        uploadImage();
    };
    return (
        <>
            <div className="flex bg-white align-center" style={{ justifyContent: 'space-between', padding: 10, borderRadius: '10px' }}>
                <div>
                    <input id={inputID} type="file" style={{ display: 'none' }} />
                    <label className="weight-500" style={{ fontSize: '20px', color: 'grey', marginBottom: 0 }} onClick={handleClickUpload}><span className="weight-400 roboto f-16">{btnName}</span></label>
                </div>
                <div>
                <img src={CloudUploadIcon} alt="" />
                </div>
            </div>
        </>
    );
}
